<app-alerts />

<div
  class="mb-8 flex items-center rounded-md bg-orange-100 p-6 text-orange-600 lg:inline-flex"
  role="alert">
  <span
    class="mr-3 flex rounded-full bg-orange-600 px-2 py-1 text-xs font-bold text-white uppercase"
    >UWAGA</span
  >
  <span class="mr-2 flex-auto text-left font-semibold">
    <ol class="list-inside list-decimal">
      <li>
        Zmiana ceny subskrypcji nie zmienia cen pojedynczego produktu, pakietu i
        subskrypcji. Pamiętaj o zmianie cen tych produktów.
      </li>
      <li>
        Zapisanie zmian spowoduje zmianę cen wszystkich subskrypcji i wysłanie
        wiadomości informacyjnej do każdego właściciela zmienianej subskrypcji.
      </li>
      <li>Aktualizowane są ceny subskrypcji aktywnych i wstrzymanych.</li>
    </ol>
  </span>
</div>

<app-admin-subscription-bulk-price-change-form
  (submitClickEvent)="handleSubmitClickEvent($event)" />
